export default __webpack_public_path__ + "static/media/AvenirLTStd-Heavy.0f01c717.otf";